import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import { Button } from "@mui/material";
import { useParams } from "react-router-dom";

const CustomizedData = ({ columns, rows, page, setPage, count, pageSize, render, sortHandler, setRows, setPageSize,
}) => {
  const { vessel } = useParams();

  useEffect(() => {
    if (setPage) setPage(page);
  }, [pageSize]);

  const onChange = (pageNumber) => {
    setPage(pageNumber);
    setRows([]);
  };

  const onSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
  };

  const [sortBy, setSortBy] = useState({
    column: null,
    order: "asc",
  });

  const handleSort = (column) => {
    sortHandler({
      columnKey: column,
      order:
        sortBy.column === column && sortBy.order === "asc"
          ? "descend"
          : "ascend",
    });

    setSortBy((prevSortBy) => ({
      column,
      order:
        prevSortBy.column === column && prevSortBy.order === "asc"
          ? "desc"
          : "asc",
    }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <div className="table_holder divcontainer">
        <table
          id="voucher_list"
          className="table table-bordered table-striped"
          style={{ border: "none" }}
        >
          <tbody>
            {rows?.length > 0 ? (
              rows.map((row, index) => render(row, index))
            ) : (
              <tr>
                <td valign="top" colSpan="8" className="dataTables_empty">
                  No matching records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {count > 10 && (
        <Pagination
          showSizeChanger
          pageSizeOptions={["5", "10", "20", "50"]}
          onShowSizeChange={onSizeChange}
          style={{ marginLeft: "auto", marginTop: "10px" }}
          defaultCurrent={page}
          current={page}
          onChange={onChange}
          total={count}
        />
      )}
    </div>
  );
};

export default CustomizedData;
